import PolicyDocumentPage from './PolicyDocumentPage'

const FALLBACK = `
<p>Welcome to DigiSutra. By using our website and services, you agree to these terms. Please read them carefully.</p>
<h2>Services</h2>
<p>DigiSutra provides digital marketing and growth services. Scope, deliverables, and fees are defined in separate agreements or proposals.</p>
<h2>Contact</h2>
<p>For questions about these terms: info@digisutra.in.</p>
`

export default function TermsPage() {
  return (
    <PolicyDocumentPage slug="terms" fallbackTitle="Terms & Conditions" fallbackHtml={FALLBACK} />
  )
}
